import React, { useContext } from 'react';
import { ISubCategoryContext, SubCategoryContext } from '../../../subCategoryState/subCategoryContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, subCategories } = useContext<ISubCategoryContext>(SubCategoryContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={subCategories.subCategoriesCount ? 800 : undefined}
		/>
	);
};

export default Search;
